import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { IDataResponse } from '@shared/model/types/dataResponse.inteface';
import { ordersRecognitionApi } from '@widgets/OrdersRecognition/api';
import { UPLOAD_ORDER_MUTATION_KEY } from '@widgets/OrdersRecognition/model/queryKeys';

export const useUploadOrder = ({
    onSuccessCb,
    onErrorCb,
}: {
    onSuccessCb?: () => void;
    onErrorCb?: (errText: string) => void;
}) => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: ordersRecognitionApi.uploadOrder,
        mutationKey: UPLOAD_ORDER_MUTATION_KEY,
        onSuccess: async (res) => {
            if (res?.data?.status === 'success') {
                await queryClient.invalidateQueries({
                    queryKey: ordersRecognitionApi.getOrdersRecognitionListQueryOptions().queryKey,
                });
                onSuccessCb?.();
            }
        },
        onError: async (err: AxiosError<IDataResponse>) => {
            onErrorCb?.(
                err?.response?.data?.message || t('OrderRecognition.Toast.Error.default.text')
            );
        },
    });
};
